module.exports = __WEBPACK_EXTERNAL_MODULE_34__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactRouterDOM","commonjs2":"react-router-dom","commonjs":"react-router-dom","amd":"react-router-dom"}
// module id = 34
// module chunks = 0